exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body.overflow-auto[data-v-590660e6]{overflow:auto}.pagination[data-v-590660e6]{display:inline-block!important}", ""]);

// exports
